module.exports = __webpack_public_path__ + "img/CATEGORY ICON-07.58b65e52.png";